import { Component, OnInit, ViewChild } from '@angular/core';
import { MDBModalService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-component-video-modal',
  templateUrl: './component-video-modal.component.html',
  styleUrls: ['./component-video-modal.component.scss']
})



export class ComponentVideoModalComponent implements OnInit {

    players: Plyr
    youtubeSources: Plyr.Source[] = [
      {
        src: '0EaaYHsawnE',
        provider: 'youtube',
      },
    ]

  constructor(private modalService: MDBModalService) {}

  ngOnInit(): void {
  }




}
